import { render, staticRenderFns } from "./newsite.vue?vue&type=template&id=4de5c6f2&scoped=true"
import script from "./newsite.vue?vue&type=script&lang=js"
export * from "./newsite.vue?vue&type=script&lang=js"
import style0 from "./newsite.vue?vue&type=style&index=0&id=4de5c6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de5c6f2",
  null
  
)

export default component.exports